import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import axios from 'axios';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import Drawer from 'material-ui/Drawer';
import { List, ListItem, ListItemIcon, ListItemText } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle } from 'material-ui/Dialog';
import User from './components/User';

import { overlapOpen } from './actions';

class Candidate extends Component {

  render(){
    const { classes, theme, location } = this.props;
    //alert(this.props.candidate_id)
    if (this.props.candidate_id=== "0000" && this.props.candidate_id == null && this.props.candidate_id < 0){
      return(
        <div></div>
      )
    } else {
      return(
        <div>
          <Dialog className={classes.root} open={this.props.overlayOpen} onRequestClose={() => this.props.overlapOpen(false, this.props.candidate_id)}>
            <div>
              <User candidate_id={this.props.candidate_id}/>
            </div>
          </Dialog>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        overlayOpen: state.candidate.open,
        candidate_id: state.candidate.id,
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
      overlapOpen: overlapOpen
    }, dispatch);
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, matchDispatchToProps)(Candidate)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/Candidate/index.js